import { registerBuiltInExtensions } from './core/registry/register';
registerBuiltInExtensions();
